import { applicationActions } from "../reducer";

import { ActiveModals } from '../../types';

export const setActiveModals = (
  activeModals: ActiveModals | null
) => applicationActions.setActiveModals(activeModals);